import React from 'react';
import ReactDOM from 'react-dom/client';
//import './index.css';
//import './output.css';
import App from './App';
import TestApp from './TestApp'; // テスト用
import TestAppMinimal from './TestAppMinimal'; // styled-components完全無効版
import reportWebVitals from './reportWebVitals';
import "./i18n/config"; //i18
import { createTheme, ThemeProvider } from '@mui/material';

const theme = createTheme();

// デバッグ用とUMD対応のためにモジュールをグローバルに公開
if (typeof window !== 'undefined') {
  window.React = React;
  window.ReactDOM = ReactDOM;
  window.App = App;
  window.TestApp = TestApp;
  window.TestAppMinimal = TestAppMinimal;
  window.createTheme = createTheme;
  window.ThemeProvider = ThemeProvider;
  console.log('🔧 All modules exposed globally for debugging and UMD access');
  console.log('Available globals:', Object.keys({React, ReactDOM, App, TestApp, TestAppMinimal, createTheme, ThemeProvider}));
}

// UMDライブラリとしてエクスポート
const OurtAI = {
  React,
  ReactDOM,
  App,
  TestApp,
  TestAppMinimal,
  createTheme,
  ThemeProvider,
  theme,
  initialize: initializeApp
};

// UMD対応のエクスポート
if (typeof window !== 'undefined') {
  window.OurtAI = OurtAI;
}

// グローバルエラーハンドリング
console.log('🔧 Setting up global error handlers...');

window.addEventListener('error', function(event) {
  console.error('🚨 Global JavaScript Error:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error
  });
});

window.addEventListener('unhandledrejection', function(event) {
  console.error('🚨 Unhandled Promise Rejection:', event.reason);
});

console.log('✅ Global error handlers set up');

// エラーハンドリングを強化
function initializeApp() {
  console.log('=== React App Initialization Started ===');
  console.log('User Agent:', navigator.userAgent);
  console.log('Current URL:', window.location.href);
  console.log('DOM Ready State:', document.readyState);
  
  try {
    console.log('Looking for root element...');
    const rootElement = document.getElementById('root');
    if (!rootElement) {
      console.error('❌ Root element not found!');
      console.log('Available elements:', document.body.innerHTML);
      return;
    }
    console.log('✅ Root element found:', rootElement);

    console.log('Creating React root...');
    const root = ReactDOM.createRoot(rootElement);
    console.log('✅ React root created successfully');
    
    console.log('Rendering App component...');
    root.render(
      // テスト用にTestAppを使用
      // <TestApp />
      // 元のAppに戻すには下記のコメントアウトを外す
      <App />
    );
    
    console.log('✅ React app rendered successfully!');
    
    // ローディング画面をフェードアウト (デバッグ強化版)
    console.log('🔍 Looking for loading screen to remove...');
    setTimeout(() => {
      const loader = document.getElementById('initial-loader');
      console.log('🔍 Loading screen element:', loader);
      
      if (loader) {
        console.log('✅ Loading screen found, starting fade out...');
        loader.classList.add('fade-out');
        
        setTimeout(() => {
          console.log('🗑️ Removing loading screen element...');
          loader.remove();
          console.log('✅ Loading screen removed successfully!');
          
          // 削除確認
          const checkRemoval = document.getElementById('initial-loader');
          if (!checkRemoval) {
            console.log('✅ Confirmed: Loading screen completely removed from DOM');
          } else {
            console.warn('⚠️ Warning: Loading screen still exists in DOM');
          }
        }, 500);
      } else {
        console.warn('⚠️ Warning: Loading screen element not found (ID: initial-loader)');
        console.log('Available elements with IDs:', 
          Array.from(document.querySelectorAll('[id]')).map(el => el.id));
      }
    }, 800); // レンダリング完了をより確実に待つ
    
    console.log('=== React App Initialization Completed ===');
  } catch (error) {
    console.error('❌ Failed to initialize React app:', error);
    console.error('Error stack:', error.stack);
    
    // フォールバック表示
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="padding: 20px; font-family: Arial, sans-serif;">
          <h2 style="color: red;">アプリケーションの初期化に失敗しました</h2>
          <p><strong>エラー:</strong> ${error.message}</p>
          <p><strong>スタック:</strong> ${error.stack}</p>
          <p>ページを再読み込みするか、開発者にお問い合わせください。</p>
        </div>
      `;
    }
  }
}

// DOM読み込み完了を待って初期化
function startApp() {
  console.log('📦 Module system check:', typeof __webpack_require__ !== 'undefined' ? 'Available' : 'Not available');
  console.log('⚛️ React availability:', typeof React !== 'undefined' ? 'Available' : 'Not available');
  console.log('🌟 ReactDOM availability:', typeof ReactDOM !== 'undefined' ? 'Available' : 'Not available');
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
  } else {
    // 既にDOMが読み込まれている場合は少し待ってから実行
    setTimeout(initializeApp, 100);
  }
}

// すぐに実行
startApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// UMDライブラリとしてのエクスポート
export default OurtAI;
export { React, ReactDOM, App, TestApp, createTheme, ThemeProvider, theme, initializeApp };
